import { useAuth } from 'src/auth/hooks/useAuth';
import { ACCOUNT_TYPE } from '../AuthApi/authApi.constants';

export const useIsInstaller = () => {
  const { user } = useAuth();
  return user.accountType === ACCOUNT_TYPE.INSTALLER;
};
